export const loanCalculatorData = [
  {
    id: 1,
    heading:
      "Axis Bank Home Loan EMI Calculator: Calculate Your Home Loan EMI with Ease",
    subHeading:
      "Use Axis Bank’s Home Loan EMI Calculator to estimate your monthly home loan repayments. This easy-to-use tool will help you calculate your EMI based on the loan amount, interest rate, and tenure. It’s designed to assist you in planning your finances more effectively, ensuring you know your repayment obligations upfront.",

    notice:
      "The calculations provided are for illustrative purposes only. Actual loan terms may vary based on the lender’s policies and your credit profile.",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];
